var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKeyestimes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.53125 8.00391C9.77734 8.27734 9.77734 8.6875 9.53125 8.93359C9.25781 9.20703 8.84766 9.20703 8.60156 8.93359L5.375 5.67969L2.12109 8.93359C1.84766 9.20703 1.4375 9.20703 1.19141 8.93359C0.917969 8.6875 0.917969 8.27734 1.19141 8.00391L4.44531 4.75L1.19141 1.49609C0.917969 1.22266 0.917969 0.8125 1.19141 0.566406C1.4375 0.292969 1.84766 0.292969 2.09375 0.566406L5.375 3.84766L8.62891 0.59375C8.875 0.320312 9.28516 0.320312 9.53125 0.59375C9.80469 0.839844 9.80469 1.25 9.53125 1.52344L6.27734 4.75L9.53125 8.00391Z",
    fill: "#808B9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyestimes);
export default __webpack_public_path__ + "static/media/keyestimes.0ba1e01c3eb7866335edb3202bd2031c.svg";
export { ForwardRef as ReactComponent };